<template>
    <div>
        <template v-if="merchantPayments === true">
            <div v-show="isDataTableLoading === false">
                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="new-tab" data-toggle="tab" href="#new" role="tab"
                                aria-controls="new" aria-selected="true" @click="reloadList('new')">New
                                ({{new_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab"
                                aria-controls="inprocess" aria-selected="false" @click="reloadList('inprocess')">In Process
                                ({{inprocess_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="processed-tab" data-toggle="tab" href="#processed" role="tab"
                                aria-controls="processed" aria-selected="false" @click="reloadList('processed')">Processed
                                ({{processed_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="disapproved-tab" data-toggle="tab" href="#disapproved" role="tab"
                                aria-controls="disapproved" aria-selected="false"
                                @click="reloadList('disapproved')">Disapproved ({{disapproved_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="error-tab" data-toggle="tab" href="#error" role="tab"
                                aria-controls="error" aria-selected="false" @click="reloadList('error')">Error
                                ({{error_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="archived-tab" data-toggle="tab" href="#archived" role="tab"
                                aria-controls="archived" aria-selected="false" @click="reloadList('archived')">Archived
                                ({{archived_batch_count}})</a>
                        </li>
                    </ul>
                    <router-link v-if="addMerchantPayment === true" to="/generateMerchantPayment"
                        class="btn btn-primary float-right mr-1"> New Batch</router-link>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <div class="table-holder">
                            <table id="merchantPaymentNewTable" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Created on</th>
                                        <th>Amount(PKR)</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="inprocess" role="tabpanel" aria-labelledby="inprocess-tab">
                        <div class="table-holder">
                            <table id="merchantPaymentInProcessTable" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Created on</th>
                                        <th>Amount(PKR)</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="processed" role="tabpanel" aria-labelledby="processed-tab">
                        <div class="table-holder">
                            <table id="merchantPaymentProcessTable" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Created on</th>
                                        <th>Amount(PKR)</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="disapproved" role="tabpanel" aria-labelledby="disapproved-tab">
                        <div class="table-holder">
                            <table id="merchantPaymentDisapproveTable" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Created on</th>
                                        <th>Amount(PKR)</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="error" role="tabpanel" aria-labelledby="error-tab">
                        <div class="table-holder">
                            <table id="merchantPaymentErrorTable" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Created on</th>
                                        <th>Amount(PKR)</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="archived" role="tabpanel" aria-labelledby="archived-tab">
                        <div class="table-holder">
                            <table id="merchantPaymentArchiveTable" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Created on</th>
                                        <th>Amount(PKR)</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <preLoader v-show="isDataTableLoading === true"></preLoader>
        </template>
        <template v-else-if="merchantPayments === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="merchantPayments === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    var gThat = null;
    export default {
        data() {
             return {
                data : null,
                new_batch_count : '...',
                inprocess_batch_count : '...',
                processed_batch_count : '...',
                disapproved_batch_count : '...',
                error_batch_count : '...',
                archived_batch_count : '...',
                merchantPayments : null,
                addMerchantPayment : null,
                currentActiveTab : 'new',
                isDataTableLoading : false,
                dtMerchantPNew : null,
                dtMerchantPInProcess : null,
                dtMerchantPProcessed : null,
                dtMerchantPError : null,
                dtMerchantPDisapproved : null,
                dtMerchantPArchived : null,
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('merchant_payments|add_merchant_payment').then(result => {
                this.merchantPayments = result.merchant_payments;
                this.addMerchantPayment = result.add_merchant_payment;
            }).then(result => {
                if(this.merchantPayments == true){
                    this.merchantPaymentNewList();
                    this.merchantPaymentInProcessList();
                    this.merchantPaymentProcessList();
                    this.merchantPaymentErrorList();
                    this.merchantPaymentDisapproveList();
                    this.merchantPaymentArchiveList();
                }
            });
        },
        methods: {
            merchantPaymentNewList: function(){
                gThat.dtMerchantPNew = $('#merchantPaymentNewTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    "sDom" : '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getMerchantPaymentNewList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.new_batch_count = json.responseJSON.recordsTotal;
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at',"mData": "created_at",'mRender':function(data,type,full){
                            var date = new Date(full['created_at']);
                            return moment(date).format('MMM D, Y');
                        }},
                        {"name":"payroll_amount","mData": "payroll_amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"status","mData": "status","mRender":function(data,type,full){
                            var status = full['status'];
                            if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status partial">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processing"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['status'];
                            var id = full['id'];
                            var userUrl = '/merchantPaymentSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['id'];
                        var $url = '/merchantPaymentSheet/'+id;
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" ><i class="far fa-eye"></i></a>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                });
            },
            merchantPaymentInProcessList: function(){
                gThat.dtMerchantPInProcess = $('#merchantPaymentInProcessTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    "sDom" : '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getMerchantPaymentInProcessList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.inprocess_batch_count = json.responseJSON.recordsTotal;
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at',"mData": "created_at",'mRender':function(data,type,full){
                            var date = new Date(full['created_at']);
                            return moment(date).format('MMM D, Y');
                        }},
                        {"name":"payroll_amount","mData": "payroll_amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"status","mData": "status","mRender":function(data,type,full){
                            var status = full['status'];
                                if(status == 1){
                                    var to_return = '<span class="status uploaded">Uploaded </span>'
                                }else if(status == 2){
                                    var to_return = '<span class="status uploaded">Under Review </span>'
                                }else if(status == 3){
                                    var to_return = '<span class="status checked"> Checked </span>'
                                }else if(status == 4){
                                    var to_return = '<span class="status partial">Partial  </span>'
                                }else if(status == 5){
                                    var to_return = '<span class="status processing"> Processed </span>'
                                }else if(status == 6){
                                    var to_return = '<span class="status disapproved">Disapproved </span>'
                                }else if(status == 7){
                                    var to_return = '<span class="status flagged"> Flagged </span>'
                                }else if(status == 8){
                                    var to_return = '<span class="status">Archive  </span>'
                                }
                            var canEdit = full['canEdit'];
                            var status = full['status'];
                            var id = full['id'];
                            var userUrl = '/merchantPaymentSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['id'];
                        var $url = '/merchantPaymentSheet/'+id;
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" ><i class="far fa-eye"></i></a>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                });
            },
            merchantPaymentProcessList: function(){
                gThat.dtMerchantPProcessed = $('#merchantPaymentProcessTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    "sDom" : '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getMerchantPaymentProcessedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.processed_batch_count = json.responseJSON.recordsTotal;
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at',"mData": "created_at",'mRender':function(data,type,full){
                            var date = new Date(full['created_at']);
                            return moment(date).format('MMM D, Y');
                        }},
                        {"name":"payroll_amount","mData": "payroll_amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"status","mData": "status","mRender":function(data,type,full){
                            var status = full['status'];
                                if(status == 1){
                                    var to_return = '<span class="status uploaded">Uploaded </span>'
                                }else if(status == 2){
                                    var to_return = '<span class="status uploaded">Under Review </span>'
                                }else if(status == 3){
                                    var to_return = '<span class="status checked"> Checked </span>'
                                }else if(status == 4){
                                    var to_return = '<span class="status partial">Partial  </span>'
                                }else if(status == 5){
                                    var to_return = '<span class="status processing"> Processed </span>'
                                }else if(status == 6){
                                    var to_return = '<span class="status disapproved">Disapproved </span>'
                                }else if(status == 7){
                                    var to_return = '<span class="status flagged"> Flagged </span>'
                                }else if(status == 8){
                                    var to_return = '<span class="status">Archive  </span>'
                                }
                            var canEdit = full['canEdit'];
                            var status = full['status'];
                            var id = full['id'];
                            var userUrl = '/merchantPaymentSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['id'];
                        var $url = '/merchantPaymentSheet/'+id;
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" ><i class="far fa-eye"></i></a>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                });
            },
            merchantPaymentErrorList: function(){
                gThat.dtMerchantPError = $('#merchantPaymentErrorTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    "sDom" : '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getMerchantPaymentErrorList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.error_batch_count = json.responseJSON.recordsTotal;
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at',"mData": "created_at",'mRender':function(data,type,full){
                            var date = new Date(full['created_at']);
                            return moment(date).format('MMM D, Y');
                        }},
                        {"name":"payroll_amount","mData": "payroll_amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"status","mData": "status","mRender":function(data,type,full){
                            var status = full['status'];
                                if(status == 1){
                                    var to_return = '<span class="status uploaded">Uploaded </span>'
                                }else if(status == 2){
                                    var to_return = '<span class="status uploaded">Under Review </span>'
                                }else if(status == 3){
                                    var to_return = '<span class="status checked"> Checked </span>'
                                }else if(status == 4){
                                    var to_return = '<span class="status partial">Partial  </span>'
                                }else if(status == 5){
                                    var to_return = '<span class="status processing"> Processed </span>'
                                }else if(status == 6){
                                    var to_return = '<span class="status disapproved">Disapproved </span>'
                                }else if(status == 7){
                                    var to_return = '<span class="status flagged"> Flagged </span>'
                                }else if(status == 8){
                                    var to_return = '<span class="status">Archive  </span>'
                                }
                            var canEdit = full['canEdit'];
                            var status = full['status'];
                            var id = full['id'];
                            var userUrl = '/merchantPaymentSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['id'];
                        var $url ='/merchantPaymentSheet/'+id;
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" ><i class="far fa-eye"></i></a>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                });
            },
            merchantPaymentDisapproveList: function(){
                gThat.dtMerchantPDisapproved = $('#merchantPaymentDisapproveTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    "sDom" : '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getMerchantPaymentDisapprovedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.disapproved_batch_count = json.responseJSON.recordsTotal;
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at',"mData": "created_at",'mRender':function(data,type,full){
                            var date = new Date(full['created_at']);
                            return moment(date).format('MMM D, Y');
                        }},
                        {"name":"payroll_amount","mData": "payroll_amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"status","mData": "status","mRender":function(data,type,full){
                            var status = full['status'];
                                if(status == 1){
                                    var to_return = '<span class="status uploaded">Uploaded </span>'
                                }else if(status == 2){
                                    var to_return = '<span class="status uploaded">Under Review </span>'
                                }else if(status == 3){
                                    var to_return = '<span class="status checked"> Checked </span>'
                                }else if(status == 4){
                                    var to_return = '<span class="status partial">Partial  </span>'
                                }else if(status == 5){
                                    var to_return = '<span class="status processing"> Processed </span>'
                                }else if(status == 6){
                                    var to_return = '<span class="status disapproved">Disapproved </span>'
                                }else if(status == 7){
                                    var to_return = '<span class="status flagged"> Flagged </span>'
                                }else if(status == 8){
                                    var to_return = '<span class="status">Archive  </span>'
                                }
                            var canEdit = full['canEdit'];
                            var status = full['status'];
                            var id = full['id'];
                            var userUrl = '/merchantPaymentSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['id'];
                        var $url = '/merchantPaymentSheet/'+id;

                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" ><i class="far fa-eye"></i></a>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                });
            },
            merchantPaymentArchiveList: function(){
                gThat.dtMerchantPArchived = $('#merchantPaymentArchiveTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    "sDom" : '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getMerchantPaymentArchivedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.archived_batch_count = json.responseJSON.recordsTotal;
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'created_at',"mData": "created_at",'mRender':function(data,type,full){
                            var date = new Date(full['created_at']);
                            return moment(date).format('MMM D, Y');
                        }},
                        {"name":"payroll_amount","mData": "payroll_amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"status","mData": "status","mRender":function(data,type,full){
                            var status = full['status'];
                                if(status == 1){
                                    var to_return = '<span class="status uploaded">Uploaded </span>'
                                }else if(status == 2){
                                    var to_return = '<span class="status uploaded">Under Review </span>'
                                }else if(status == 3){
                                    var to_return = '<span class="status checked"> Checked </span>'
                                }else if(status == 4){
                                    var to_return = '<span class="status partial">Partial  </span>'
                                }else if(status == 5){
                                    var to_return = '<span class="status processing"> Processed </span>'
                                }else if(status == 6){
                                    var to_return = '<span class="status disapproved">Disapproved </span>'
                                }else if(status == 7){
                                    var to_return = '<span class="status flagged"> Flagged </span>'
                                }else if(status == 8){
                                    var to_return = '<span class="status">Archive  </span>'
                                }
                            var canEdit = full['canEdit'];
                            var status = full['status'];
                            var id = full['id'];
                            var userUrl = '/merchantPaymentSheet/'+id;
                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['id'];
                        var $url = '/merchantPaymentSheet/'+id;
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" ><i class="far fa-eye"></i></a>';},
                        visible: gThat.crud_region},
                            ],
                            "order": [[ 0, "desc" ]],
                        });
            },
            reloadList(tabClicked){

				switch(tabClicked)
				{
					case 'new':
						if(gThat.currentActiveTab !== 'new')
						{
							gThat.isDataTableLoading = true;

							gThat.dtMerchantPNew.ajax.reload(function(json){
								gThat.new_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 	= false;
							}, false);

							gThat.currentActiveTab = 'new';	
						}
					break;

					case 'inprocess':
						if(gThat.currentActiveTab !== 'inprocess')
						{
							gThat.isDataTableLoading = true;

							gThat.dtMerchantPInProcess.ajax.reload(function(json){
								gThat.inprocess_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'inprocess';
						}
					break;

					case 'processed':
						if(gThat.currentActiveTab !== 'processed')
						{
                            gThat.isDataTableLoading = true;
                            
							gThat.dtMerchantPProcessed.ajax.reload(function(json){
								gThat.processed_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'processed';
						}
					break;

					case 'disapproved':
						if(gThat.currentActiveTab !== 'disapproved')
						{
                            gThat.isDataTableLoading = true;

							gThat.dtMerchantPDisapproved.ajax.reload(function(json){
								gThat.disapproved_batch_count = json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'disapproved';
						}
					break;

					case 'error':
						if(gThat.currentActiveTab !== 'error')
						{
                            gThat.isDataTableLoading = true;
                            
							gThat.dtMerchantPError.ajax.reload(function(json){
								gThat.error_batch_count 		= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'error';
						}
					break;

					case 'archived':
						if(gThat.currentActiveTab !== 'archived')
						{
                            gThat.isDataTableLoading = true;
                            
							gThat.dtMerchantPArchived.ajax.reload(function(json){
								gThat.archived_batch_count = json.recordsTotal;
								gThat.isDataTableLoading 	 = false;
							}, false);

							gThat.currentActiveTab = 'archived';
						}
					break;
				}
			}
        }
    }
</script>
